export default "__VITE_ASSET__BOvUsVsJ__"